





import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    'landing': require('./Landing.vue').default,
    'dashboard': require('./Dashboard.vue').default,
  },
})
export default class Home extends Vue {

}
